import React, {Component} from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import {newRelease, releaseShown} from './Attention'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandsHelping} from "@fortawesome/free-solid-svg-icons";
import UserDropdown from './Userdropdown'
import {NavBreadcrumb} from './Breadcrumb'
import BillingBreadcrumb from './BillingBreadcrumb';
import GrantApprove from '../Grants/GrantApprove'
import {GrantRequests} from '../Grants/GrantRequests'
import { FavIcon } from '../Decorators/Favorite';
import { addFavorite, favRead } from '../Overview/MostRecent';
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import SideBar from '../CmdLine/CmdLine'
import SecondServer from '../database/SecondServer'

import "./topnav.css";

export function siteListNav(props) {
  props.clearCrumb()
  props.history.push("/")
}

export default class TopNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkGrants: false,
      grantIcon: 'rgba(0, 0, 0, 0.5)',
      forceRefresh: 0,
    }
    this.ss = new SecondServer(props)
    this.attention = newRelease(props)
    this.help = this.help.bind(this);
    this.showGrants = this.showGrants.bind(this)
    this.hideGrants = this.hideGrants.bind(this)
    this.whatsnew = this.whatsnew.bind(this)
    this.setBillingContextTopNav = this.setBillingContextTopNav.bind(this);
  }
  async componentDidMount() {
    this.props.loginExpired();
    const req = await GrantRequests(this.props, this.ss)
    this.grantIconColor (req?.req?.length ?? 0)
  }
  componentDidUpdate(prevProps) {
    if (prevProps.grantReq !== this.props.grantReq) {
      this.grantIconColor(this.props.grantReq)
    }
  }
  componentWillUnmount() {
    this.ss.cancel()
  }
  grantIconColor (reqCount) {
    const color = reqCount > 0 ? 'rgba(0, 255, 128, 0.8)' : 'rgba(0, 0, 0, 0.5)'
    this.setState({grantIcon: color})
  }
  setBillingContextTopNav = (index) => {
    this.props.setbillingcontext(index)
  }
  help() {
    const helpUrl = this.props?.siteLocation ? "/FAQ#"+this.props.siteLocation : "/FAQ"
    window.open(helpUrl, "_blank");
  }
  whatsnew() {
    this.attention = false
    releaseShown(this.props)
    window.open("/whatsnew", "_blank")
  }
  report() {
    window.open("https://form.asana.com/?k=vVJs5jjzL6U4ddUh7RwUWg&d=19392645622611", "_blank")
  }
  showGrants() {
    this.setState ({checkGrants:true})
  }
  hideGrants(){
    this.setState({checkGrants:false})
  }
  setFave = () => {
    const faveSite = this.props.getActiveSite()
    if (faveSite) {
      addFavorite(faveSite, this.props.userLogin)
      this.setState ({forceRefresh: this.state.forceRefresh+1})
    }
  }
  showFavorite () {
    const site = this.props.getActiveSite()
    if (site && this.props?.menucontext === 'sitelist') {
      const fav = favRead(this.props.userLogin)
      const onFavSite = fav.find(s => s?.ac === siteAccessCode(site))
      const iconProps = onFavSite ? {fill:'#ffcc00ff'} : {}
      const tip = onFavSite ? "Favorite!" : "Add to Favorites"
      return (
        <span  className="navbar-spacer navbar-icon tipped" onClick={this.setFave}>
          <span className="mrutooltip">{tip}</span>
          <FavIcon {...iconProps} /> 
        </span>
      )
    }
    return null
  }
  render() {
    const clickStyle = {color: "black", cursor: "pointer"}
    return (
      <Navbar fixed="top" expand="lg" className="navbar-bg py-1">
        <Container>
        {this.props.menucontext !== "billing" && (
          <NavBreadcrumb {...this.props} />
        )}
        {this.props.menucontext === "billing" && (
          <BillingBreadcrumb {...this.props} items={this.props.billingbreadcrumbItems} setbillingcontext={this.setBillingContextTopNav}/>
        )}
        <Nav className="ml-auto">
          <Navbar.Text style={clickStyle} onClick={this.report}
            className="navbar-spacer ">Report Issue
          </Navbar.Text>
          <Navbar.Text style={clickStyle} onClick={this.whatsnew}
           className="navbar-spacer ">What's New
           {this.attention ? <span className="attention-dot"></span> : null}
          </Navbar.Text>
          <Navbar.Text style={clickStyle} onClick={this.help}
           className="navbar-spacer tour-help-link">Help
          </Navbar.Text>
          {this.showFavorite()}
          <Navbar.Text style={{ color: "black" }} className="navbar-spacer">
            {this.props.userLogin}
          </Navbar.Text>
          <Navbar.Text className="navbar-spacer" style={{color: this.state.grantIcon, cursor: "pointer" }} 
            onClick={this.showGrants}> <FontAwesomeIcon icon={faHandsHelping} size="lg" />
          </Navbar.Text>
          <GrantApprove {...this.props} show={this.state.checkGrants} hide={this.hideGrants}/>
          <SideBar {...this.props} clickStyle={clickStyle}/>
          <UserDropdown {...this.props} />
        </Nav>
        </Container>
      </Navbar>
    );
  }
}
// goes in front of userDropdown for release
//          <SideBar {...this.props} clickStyle={clickStyle}/>
